export default __webpack_public_path__ + "static/media/double-chevron.514f4e16.svg";